__turbopack_context__.v({
  "container-page": "jIzkvG_container-page",
  "form-greeting": "jIzkvG_form-greeting",
  "image-content": "jIzkvG_image-content",
});
